const moneyFormatter = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const dateTimeFormatter = new Intl.DateTimeFormat("de-DE", {
  timeZone: "Europe/Berlin",
  dateStyle: "medium",
  timeStyle: "short",
});

const dateFormatter = new Intl.DateTimeFormat("de-DE", {
  timeZone: "Europe/Berlin",
  dateStyle: "medium",
});

export function formatBucks(value: unknown, isMinor = true): string {
  const amount = typeof value === "number" && Number.isFinite(value) ? value : 0;
  return `${moneyFormatter.format(isMinor ? amount / 100 : amount)} Bucks`;
}

export function formatDateTime(value: unknown): string {
  if (typeof value !== "string" && typeof value !== "number" && !(value instanceof Date))
    return "—";
  const date = new Date(value);
  return Number.isNaN(date.valueOf()) ? "—" : dateTimeFormatter.format(date);
}

export function formatDate(value: unknown): string {
  if (typeof value !== "string" && typeof value !== "number" && !(value instanceof Date))
    return "—";
  const date = new Date(value);
  return Number.isNaN(date.valueOf()) ? "—" : dateFormatter.format(date);
}

export function formatFileSize(value: unknown): string {
  if (typeof value !== "number" || !Number.isFinite(value) || value < 0) return "—";
  if (value < 1024) return `${value} B`;
  if (value < 1024 ** 2) return `${(value / 1024).toFixed(1).replace(".", ",")} KB`;
  return `${(value / 1024 ** 2).toFixed(1).replace(".", ",")} MB`;
}

export function initials(name: string): string {
  return (
    [...name.trim()]
      .filter((character) => /\p{L}|\p{N}/u.test(character))
      .slice(0, 2)
      .join("")
      .toLocaleUpperCase("de-DE") || "FB"
  );
}

export function safeDirection(value: string): "ltr" | "rtl" | "auto" {
  return /[\u0590-\u08ff]/u.test(value) ? "auto" : "ltr";
}
